import React from 'react';
import { Clock, Mail, LogOut } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';
import { useNavigate } from 'react-router-dom';

export default function PendingApproval() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-900 via-orange-900 to-yellow-900 flex items-center justify-center p-4">
      <div className="max-w-md w-full">
        <div className="bg-white/10 backdrop-blur-md border border-white/20 rounded-2xl p-8 text-center">
          <div className="inline-flex items-center justify-center w-20 h-20 bg-orange-500/20 rounded-full mb-6">
            <Clock className="w-10 h-10 text-orange-400 animate-pulse" />
          </div>
          
          <h1 className="text-3xl font-bold text-white mb-4">
            Esperando Aprobación
          </h1>
          
          <div className="mb-6">
            {user?.photo && (
              <img 
                src={user.photo} 
                alt={user.name}
                className="w-16 h-16 rounded-full mx-auto mb-3 border-2 border-white/20"
              />
            )}
            <p className="text-gray-300 mb-2">
              Hola <span className="font-semibold text-white">{user?.name}</span>
            </p>
            <p className="text-sm text-gray-400">{user?.email}</p>
          </div>
          
          <div className="bg-white/5 rounded-lg p-4 mb-6 text-left">
            <p className="text-gray-300 text-sm mb-3">
              Tu cuenta ha sido creada exitosamente, pero aún no tienes roles asignados.
            </p>
            <p className="text-gray-300 text-sm">
              Un administrador debe asignarte permisos para acceder a las áreas del dashboard.
            </p>
          </div>

          <div className="bg-blue-500/20 border border-blue-500/50 rounded-lg p-4 mb-6">
            <div className="flex items-start space-x-3">
              <Mail className="w-5 h-5 text-blue-400 mt-0.5 flex-shrink-0" />
              <div className="text-left">
                <p className="text-sm text-blue-200 font-semibold mb-1">
                  ¿Qué hacer mientras tanto?
                </p>
                <p className="text-xs text-blue-300">
                  Contacta a un administrador del sistema para que te asigne los roles necesarios.
                  Una vez asignados, podrás acceder al dashboard.
                </p>
              </div>
            </div>
          </div>

          <button
            onClick={handleLogout}
            className="w-full flex items-center justify-center space-x-2 bg-white/10 hover:bg-white/20 text-white px-6 py-3 rounded-lg font-semibold transition-all duration-200"
          >
            <LogOut className="w-5 h-5" />
            <span>Cerrar Sesión</span>
          </button>

          <p className="text-xs text-gray-400 mt-4">
            Refresca la página después de que te asignen roles
          </p>
        </div>
      </div>
    </div>
  );
}
